import { useMatches } from 'react-router';
import type { ContentGateState } from './content-gate';

/**
 * Whether the page currently rendered is closing its grid with the content gate.
 *
 * Read from route loader data rather than a shared atom so it is true from the
 * first render of the page, before the panel itself has mounted — the site-wide
 * prompts that consult it queue on navigation, and a signal that arrived later
 * would let one through in the meantime.
 *
 * Those prompts suppress themselves here so a visitor never meets two auth walls
 * at once: the blurred grid is already the ask, and a modal over the top of it
 * would be the second one in the same breath.
 */
export const useContentGateActive = (): boolean => {
    const matches = useMatches();

    return matches.some(
        (match) =>
            (match.data as { contentGate?: ContentGateState } | null)
                ?.contentGate?.gated === true,
    );
};
